// extracted by mini-css-extract-plugin
export default {"ConsultationTypes":"ConsultationTypes_ConsultationTypes__el2og","TypeContainer":"ConsultationTypes_TypeContainer__IYJVc"};